const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

export const ArjeeApi = {
  AddArjee: `${BASE_URL}/add-arjee`,
  Arjee: `${BASE_URL}/arjee`,
  GetArjeeMessage: (id, index = 0, type = "") =>
    `${BASE_URL}/arjee/${id}/message?index=${index}${type ? `&type=${type}` : ""}`,
  Slots: `${BASE_URL}/slots`,
  EditSlots: `${BASE_URL}/editslots`,
  UploadVAImage: `${BASE_URL}/add-va-image`,
  ExtractTokens: `${BASE_URL}/extract-tokens-from-images`,
  GetAllJobs: `${BASE_URL}/ai-extraction-jobs`,
  GetJobFull: (jobId) => `${BASE_URL}/ai-extraction-jobs/${jobId}`,
  DeleteJob: (jobId) => `${BASE_URL}/ai-extraction-jobs/${jobId}`,
  DeleteJobImage: (jobId, imageId) =>
    `${BASE_URL}/ai-extraction-jobs/${jobId}/images/${imageId}`,
  RetryExtractionJob: (jobId) =>
    `${BASE_URL}/ai-extraction-jobs/${jobId}/retry`,
  ExtractTokenStatus: (jobId) =>
    `${BASE_URL}/extract-tokens-from-images/${jobId}`,
  PublishExtractionJob: (jobId) =>
    `${BASE_URL}/extract-tokens-from-images/${jobId}/publish`,
  ConvertArjeeToVA: `${BASE_URL}/convert-arjee-to-va`,
  TodayArjee: `${BASE_URL}/today-arjee`,
  VAUpdate: `${BASE_URL}/vyaktigat-arjee-update`,
};

export const ReviewsApi = {
  Reviews: `${BASE_URL}/reviews`,
  HomeReviews: `${BASE_URL}/home-reviews`,
};

export const UserApi = {
  Login: `${BASE_URL}/login`,
  AshokaLogin: `${BASE_URL}/ashoka-login`,
};

export const ArjeeVideoApi = {
  UploadVAVideo: `${BASE_URL}/upload-vyaktigat-arjee-video`,
  UploadDAVideo: `${BASE_URL}/upload-dainik-arjee-video`,
  UploadGSVideo: `${BASE_URL}/upload-gau-seva-video`,
  Notes: `${BASE_URL}/notes`,
};

export const LakhiMelaApi = {
  GetMelaDetails: `${BASE_URL}/lakhi-mela`,
  UpdateMelaDetails: `${BASE_URL}/lakhi-mela/update-all`,
};

export const GroundApi = {
  GetPayment: `${BASE_URL}/payments`,
};

export const ImageApi = {
  GetImages: `${BASE_URL}/getImages`,
  DeleteImage: `${BASE_URL}/deleteImage`,
  AddImage: `${BASE_URL}/addImage`,
};

export const GalleryApi = {
  GetImages: `${BASE_URL}/gallery`,
  AddImage: `${BASE_URL}/gallery`,
  ReorderImages: `${BASE_URL}/gallery/reorder`,
  DeleteImage: `${BASE_URL}/gallery`,
};

export const BheedApi = {
  Bheed: `${BASE_URL}/bheed`,
  EditBheedDetails: `${BASE_URL}/edit-bheed-details`,
};

export const ParamStaysApi = {
  CheckAvailability: `${BASE_URL}/hotel-booking/check-availability`,
  UpdateStatus: `${BASE_URL}/hotel-booking`,
  GetBookings: `${BASE_URL}/hotel-booking/get-bookings`,
  UpdateRange: `${BASE_URL}/hotel-booking/update-range`,
  GetRoomPrices: `${BASE_URL}/hotel-booking/get-room-prices`,
  UpdateRoomPrices: `${BASE_URL}/hotel-booking/update-room-prices`,
};

export const SwayamArjeeApi = {
  SwayamArjeeSlot: `${BASE_URL}/swayam-arjee-slot`,
  SwayamArjee: `${BASE_URL}/swayam-arjee`,
  MarkSwayamArjee: `${BASE_URL}/mark-swayam-arjee`,
};

export const NotificationApi = {
  Send: `${BASE_URL}/notifications/send`,
  History: `${BASE_URL}/notifications/history`,
  Stats: `${BASE_URL}/notifications/stats`,
  SendDainikArjee: `${BASE_URL}/notifications/send-dainik-arjee`,
  SendVyaktigatArjee: `${BASE_URL}/notifications/send-vyaktigat-arjee`,
  SendEkadashiArjee: `${BASE_URL}/notifications/send-ekadashi-arjee`,
};

export const FeedbackApi = {
  GetAll: `${BASE_URL}/feedbacks`,
  Update: `${BASE_URL}/feedbacks`,
};

export const ErrorLogApi = {
  GetAll: `${BASE_URL}/errors`,
  Resolve: (id) => `${BASE_URL}/errors/${id}/resolve`,
  Delete: (id) => `${BASE_URL}/errors/${id}`,
  ClearResolved: `${BASE_URL}/errors/clear-resolved`,
  BulkDelete: `${BASE_URL}/errors/bulk-delete`,
};

export const SocketUrl = process.env.REACT_APP_BACKEND_URL;

export const CallbackRequestApi = {
  GetAll: `${BASE_URL}/callback-requests`,
  Update: `${BASE_URL}/callback-requests`,
};

export const R2FilesApi = {
  GetFiles: (folder) => `${BASE_URL}/r2-files/${folder}`,
  DeleteFile: `${BASE_URL}/r2-files`,
};

const BLOG_BASE_URL = `${BASE_URL}`;
const PUBLIC_BLOG_URL = `${process.env.REACT_APP_BACKEND_URL}/api/blog`;

export const BlogApi = {
  GetAll: PUBLIC_BLOG_URL,
  GetAllAdmin: `${BLOG_BASE_URL}/blog`,
  GetBySlug: (slug) => `${PUBLIC_BLOG_URL}/${slug}`,
  GetByIdAdmin: (id) => `${BLOG_BASE_URL}/blog/${id}`,
  Create: `${BLOG_BASE_URL}/blog`,
  Update: (id) => `${BLOG_BASE_URL}/blog/${id}`,
  Delete: (id) => `${BLOG_BASE_URL}/blog/${id}`,
  UploadCover: `${BLOG_BASE_URL}/blog/upload-cover`,
};

export const CsvUploadApi = {
  Base: `${BASE_URL}/csv-upload`,
};

export const CsvExporterApi = {
  GetData: `${BASE_URL}/csv-exporter/data`,
};

export const CsvTagApi = {
  Base: `${BASE_URL}/csv-tags`,
};

export const BhogArjeeApi = {
  Base: `${BASE_URL}/bhog-arjees`,
  Update: `${BASE_URL}/bhog-arjees/mark-done`,
};
export const ChatbotApi = {
  Stats: `${BASE_URL}/chatbot/stats`,
  Logs: `${BASE_URL}/chatbot/logs`,
  Sessions: `${BASE_URL}/chatbot/sessions`,
  SessionDetail: (sessionId) => `${BASE_URL}/chatbot/sessions/${sessionId}`,
  ClearCache: `${BASE_URL}/chatbot/clear-cache`,
  ClearData: `${BASE_URL}/chatbot/clear-data`,
};

export const WaApi = {
  Leads: `${BASE_URL}/wa/leads`,
  ExportMetaAudience: `${BASE_URL}/wa/export-meta-audience`,
  LeadDetail: (phone) => `${BASE_URL}/wa/leads/${phone}`,
  DevoteeArjees: (phone) => `${BASE_URL}/wa/devotee-arjees/${phone}`,
  Messages: (phone) => `${BASE_URL}/wa/messages/${phone}`,
  SendMessage: (phone) => `${BASE_URL}/wa/send/${phone}`,
  ToggleAi: (phone) => `${BASE_URL}/wa/leads/${phone}/ai`,
  MarkRead: (phone) => `${BASE_URL}/wa/leads/${phone}/read`,
  MarkUnread: (phone) => `${BASE_URL}/wa/leads/${phone}/unread`,
  Categories: `${BASE_URL}/wa/categories`,
  CategoryUpdate: (id) => `${BASE_URL}/wa/categories/${id}`,
  CategoryDelete: (id) => `${BASE_URL}/wa/categories/${id}`,
  LeadCategories: (phone) => `${BASE_URL}/wa/leads/${phone}/categories`,
  Broadcasts: `${BASE_URL}/wa/broadcasts`,
  BroadcastDetail: (id) => `${BASE_URL}/wa/broadcasts/${id}`,
  Logs: `${BASE_URL}/wa/logs`,
  GlobalAi: `${BASE_URL}/wa/global-ai`,
  QuickReplies: `${BASE_URL}/wa/quick-replies`,
  QuickReplyAction: (id) => `${BASE_URL}/wa/quick-replies/${id}`,
  AssignLead: (phone) => `${BASE_URL}/wa/leads/${phone}/assign`,
  SetFollowUp: (phone) => `${BASE_URL}/wa/leads/${phone}/followup`,
  UpdateContext: (phone) => `${BASE_URL}/wa/leads/${phone}/context`,
  ArchiveLead: (phone) => `${BASE_URL}/wa/leads/${phone}/archive`,
  ExportChat: (phone) => `${BASE_URL}/wa/export/${phone}`,
};

export const CouponApi = {
  Base: `${BASE_URL}/coupons`,
  GetById: (id) => `${BASE_URL}/coupons/${id}`,
  AddNumbers: (id) => `${BASE_URL}/coupons/${id}/add-numbers`,
  RemoveNumber: (id) => `${BASE_URL}/coupons/${id}/remove-number`,
};
export const MiscApi = {
  Feedbacks: `${BASE_URL}/feedbacks`,
  RegisterFCMToken: `${BASE_URL}/admin-fcm-token`,
};

export const SwayamReferralApi = {
  Base: `${BASE_URL}/swayam-referral`,
};

export const ArjeeTrackingApi = {
  Base: `${BASE_URL}/arjee-tracking`,
  LapsedArjees: `${BASE_URL}/lapsed-arjees`,
  Tags: `${BASE_URL}/arjee-tracking/tags`,
};

export const ActiveTrackingApi = {
  Base: `${BASE_URL}/active-tracking`,
  Tag: `${BASE_URL}/active-tracking/tag`,
  Sync: `${BASE_URL}/active-tracking/sync`,
};

export const MapRouteApi = {
  Logs: `${BASE_URL}/map-routes/logs`,
  Reports: `${BASE_URL}/map-routes/reports`,
  Nodes: `${BASE_URL}/map-routes/nodes`,
  Routes: `${BASE_URL}/map-routes/routes`,
};
